
import { mapState } from 'vuex'
export default {
    data() {
        return {
            forceToAddBankAccountModal: false,
            forceToAddWalletAddressModal: false,
            paymentType: 'bank',
            disabledBank: true,
            disableCryptoPayment: true,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
            depositFlow: (state) => state.themes.deposit.depositFlow,
            operationSetting: (state) => state.settings.operationSetting,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
            exchangeRateLoading: (state) =>
                state.themes.settings.exchangeRateLoading,
            createWithdrawalLoading: (state) =>
                state.themes.withdraw.createWithdrawalLoading,
            createCryptoWithdrawalLoading: (state) =>
                state.themes.withdraw.createCryptoWithdrawalLoading,
        }),
        depositType() {
            if (!this.depositFlow.deposit_type) return null
            return ~~this.depositFlow.deposit_type
        },
        showCryptoCurrency() {
            if (this.depositType === 1) return false
            return (
                this.depositFlow.is_crypto_payment_enabled ||
                ~~this.operationSetting?.reg_flow === 5
            )
        },
    },
    watch: {
        player(value) {
            if (value.currency) {
                this.checkWebsiteSettings()
                this.checkIfWithdrawalExist()
                this.paymentType =
                    value?.currency === 'USDT' ? 'crypto' : 'bank'
            }
        },
        operationSetting(value) {
            // only international
            if (value?.reg_flow) {
                const hasBankAccount = this.player.has_bank_account
                if (hasBankAccount === false && ~~value?.reg_flow === 2) {
                    this.forceToAddBankAccountModal = true
                }
            }
        },
    },
    async mounted() {
        await this.checkIfWithdrawalExist()
        this.checkWebsiteSettings()

        this.$store.dispatch(
            'settings/operationSetting',
            this.$cookie.get('player')?.currency
        )

        this.$root.withdrawExistChange = (item) => {
            if (!item?.is_exist) {
                if (this.steppers !== 3) {
                    this.steppers = 1
                }
                this.steppers = 1
                this.resultData = {}
                this.disableCryptoPayment = false
                this.disabledBank = false
            } else {
                this.resultData = item
            }
        }
    },
    destroyed() {
        this.$root.withdrawExistChange = null
    },
    methods: {
        checkWebsiteSettings() {
            const hasBankAccount = this.player.has_bank_account
            if (hasBankAccount === false && !this.isInternational) {
                this.forceToAddBankAccountModal = true
            }
        },
        async checkIfWithdrawalExist() {
            if (this.player?.has_bank_account) {
                const result = await this.$store.dispatch(
                    'themes/withdraw/checkExistWithdrawal'
                )
                if (result?.is_exist) {
                    this.resultData = result
                    this.steppers = 2
                    if (result.channel === 'crypto') {
                        this.disableAutoDeposit = true
                        this.paymentType = 'crypto'
                    } else if (
                        result.channel === 'third_party' ||
                        result.channel === 'manual_transfer'
                    ) {
                        this.disableCryptoPayment = true
                        this.paymentType = 'bank'
                    }
                } else {
                    this.disableCryptoPayment = false
                    this.disabledBank = false
                }
            }
        },
        enableDisabledPaymentMethod(data) {
            if (data?.is_exist === true && data?.channel === 'crypto') {
                this.paymentType = 'crypto'
                this.disabledBank = true
            } else if (data?.is_exist === true && data?.channel === 'bank') {
                this.paymentType = 'bank'
                this.disableCryptoPayment = true
            } else {
                this.disabledBank = false
                this.disableCryptoPayment = false
            }
        },
    },
}
